
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { InfiniteData } from '@tanstack/react-query';
import { SkeletonLoader, EmptyRecord, ProductPromo } from '../../../../components';
import { IPagedDataResponse, IProduct } from '../../../../types';
import styles from './CatalogueProducts.module.scss';
import { Card } from '@orderly/morrisons-component-library';
import ProductList from '../ProductList';

interface ICatalogueProducts {
  data: InfiniteData<IPagedDataResponse<IProduct[]>>;
  displayMode: string;
  fetchNextPage: () => void;
  maxOrderQuantity: number;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
}

const CatalogueProducts = ({
  data,
  displayMode,
  fetchNextPage,
  hasNextPage,
  maxOrderQuantity,
  isFetchingNextPage,
  isLoading,
}: Readonly<ICatalogueProducts>) => {

  if (isLoading) {
    return (
      <Card className={styles.loadingCard}>
        <SkeletonLoader />
      </Card>
    );
  }

  if (data === undefined) {
    return (null);
  }

  const products = data.pages.flatMap((page: IPagedDataResponse<IProduct[]>) =>
    page.data.map(product => product),
  );

  if (products.length === 0) {
    return (
      <div className={styles.emptyRecord}>
        <EmptyRecord message={'No Products Found'} />
      </div>
    );
  }

  return (
    <div className={`${styles.productsWrapper} ${displayMode === 'grid' ? styles.grid : ''}`}>
      <InfiniteScroll
        pageStart={0}
        loadMore={fetchNextPage}
        hasMore={hasNextPage && !isFetchingNextPage}
        loader={null}
      >
        {
          displayMode === 'grid' ?
            products.map(x =>
              <ProductPromo
                key={`catalogue_promo_${x.id}`}
                product={x}
                lazyLoad
                maxOrderQuantity={maxOrderQuantity}
              />,
            ) :
            <ProductList
              products={products}
              maxOrderQuantity={maxOrderQuantity}
            />
        }
      </InfiniteScroll>
    </div>
  );
};

export default CatalogueProducts;
